import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgProductUsageAnalytics = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.2222 4H5.77778C4.8 4 4 4.8 4 5.77778V18.2222C4 19.2 4.8 20 5.77778 20H18.2222C19.2 20 20 19.2 20 18.2222V5.77778C20 4.8 19.2 4 18.2222 4ZM18.2222 18.2222H5.77778V5.77778H18.2222V18.2222ZM7.55556 10.2222H9.33333V16.4444H7.55556V10.2222ZM11.1111 7.55556H12.8889V16.4444H11.1111V7.55556ZM14.6667 12.8889H16.4444V16.4444H14.6667V12.8889Z",
		fill: "currentColor"
	})
});
export default SvgProductUsageAnalytics;
